import { FieldConfig, GenericFieldHTMLAttributes, Field } from 'formik'
import { TextFieldProps, InputLabel } from '@material-ui/core'

import { INPUT_CARD_EXPIRATION_MASK } from 'src/utils/masks'

import { POSTextMask } from 'src/components'

export type POSFieldCardExpirationrops = GenericFieldHTMLAttributes &
    FieldConfig &
    TextFieldProps

export const POSFieldCardExpiration = ({
    label,
    ...props
}: POSFieldCardExpirationrops) => (
    <>
        <InputLabel>{label}</InputLabel>
        <Field
            component={POSTextMask}
            mask={INPUT_CARD_EXPIRATION_MASK}
            variant="filled"
            fullWidth
            inputProps={{
                inputMode: 'numeric',
            }}
            {...props}
        />
    </>
)
